import { useAuth } from "@/context/AuthContext";
import MediaBrowser from "@/components/cms/MediaBrowser";

export default function CmsMedia() {
  const { profile } = useAuth();
  return (
    <div data-testid="cms-media" className="space-y-6">
      <section>
        <p className="text-xs font-bold uppercase tracking-[0.15em] text-neutral-500">
          Content
        </p>
        <h1 className="mt-1 font-heading text-3xl font-semibold tracking-tight text-neutral-900 sm:text-4xl">
          Media library
        </h1>
        <p className="mt-2 max-w-2xl text-neutral-600">
          Images and files you can drop into pages and announcements. Everything
          is private to your organization.
        </p>
      </section>

      <section className="rounded-2xl border border-neutral-200 bg-white p-5">
        <MediaBrowser
          organizationId={profile?.organization_id}
          mode="manage"
          embed
        />
      </section>
    </div>
  );
}
